<template>
  <div>
    <v-row dense>
      <v-col cols="12" class="font-weight-bold">
        Alterações nos produtos:
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" v-for="negociacaoProduto in negociacao.produtos"
             :key="negociacaoProduto.id">
        <span class="caption font-weight-bold">
          <px-produto-descricao
            :especificacao="negociacaoProduto.respostaProduto.cotacaoProduto.especificacaoProduto"
            :produto="negociacaoProduto.respostaProduto.cotacaoProduto.produto"/>
        </span>
        <px-negociacao-diff-campo v-for="(campo, index) in negociacaoProduto.negociacao.campos"
                                  :key="index"
                                  :campo="campo"
                                  :value-changed-class="valueClass"
                                  :precision="precision(negociacaoProduto)"
                                  :simbolo-moeda="simboloMoeda"
                                  :configuracao-moeda="configuracaoFormatacaoMoeda"
                                  :negociacao="negociacaoProduto.negociacao"
                                  :download-file-path="downloadFilePath"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { TipoNegociacao } from 'px-business-components';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  props: {
    negociacao: {
      type: Object,
      required: true,
    },
    resposta: {
      type: Object,
      required: true,
    },
    downloadFilePath: String,
  },
  computed: {
    moeda() {
      return this.resposta.moeda;
    },
    precision() {
      return (negociacaoProduto) => {
        const { produto } = negociacaoProduto.respostaProduto.cotacaoProduto;
        return produto.casasDecimais;
      };
    },
    valueClass() {
      if (this.negociacao.tipo === TipoNegociacao.keys.RESPOSTA.key) {
        return 'green--text font-weight-bold';
      }
      return 'orange--text font-weight-bold';
    },
  },
};
</script>
